import { Inject, Injectable } from '@angular/core';
import { StorageInjectionToken } from '@fleet-beat/libs-core/src/lib/injection-tokens/storage.injection-token';

@Injectable({ providedIn: 'root' })
export class CacheService {
  constructor(@Inject(StorageInjectionToken) private storage: Storage) {}

  getItem<T>(key: string): T | null {
    const dataStr: string = this.storage.getItem(key);
    if (!dataStr) return null;
    const data: T = JSON.parse(dataStr);

    return data;
  }

  setItem<T>(key: string, value: T): void {
    const existData: T | null = this.getItem<T>(key);
    if (!existData) {
      this.storage.setItem(key, JSON.stringify(value));
      return;
    }

    const data: T = { ...existData, ...value };
    this.storage.setItem(key, JSON.stringify(data));
  }

  removeItem(key: string): void {
    this.storage.removeItem(key);
  }
}
